import axios from "axios";
import { api } from "./api_route";


export const allEmpanelmentRegistration = async (values) => {
  try {
    const result = await axios.get(`${api}/boardsAndPanel/all`);
    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};


export const boardsAndPanelEmpanelmentRegistrationView = async (values) => {
  try {

    
    const result = await axios.get(`${api}/boardsAndPanel/view/${values}`);

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    console.log(error.message)
    return [];
  }
};

export const boardsAndPanelEmpanelmentRegistrationDocumentView = async (values) => {
  try {
    const result = await axios.get(`${api}/empanelRegistrationDocument/${values}`, {
      responseType: 'blob',
    });

    
    
    
    const blob = new Blob([result.data], {
      type: result.headers['content-type'] || 'image/png'
    });

    
    const objectUrl = URL.createObjectURL(blob);

    return {
      data: blob,
      objectUrl: objectUrl,
      fileName: values, 
      contentType: result.headers['content-type'],
      status: result.status,
    };
  } catch (error) {
    console.log('Error:', error.message);
    return { error: error.message };
  }
};


export const boardsAndPanelEmpanelmentFetchDocument = async (values) => {
  try {

    const result = await axios.get(`${api}/boardsAndPanel/fetchDocument/${values}`);

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    console.log(error.message)
    return [];
  }
};



export const boardsAndPanelEmpanelmentProfessionalRegistration = async (values) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/professionalRegistration`,values,
      values
    );

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};


export const boardsAndPanelEmpanelmentPersonalDetails = async (values) => {
  try {
    const result = await axios.post(
      `${api}/boardsAndPanel/empanelmentPersonalDetails`,
      values
    );

    return {
      data: result.data,
      status: result.status,
    };
  } catch (error) {
    return [];
  }
};




export const boardsAndPanelEmpanelmentProfessionalDetails = async (values) => {
  try {
    const result = await axios.post(`${api}/boardsAndPanel/professionalDetails`,values);

    return values !== "" ? result.data : "";
  } catch (error) {
    return [];
  }
};


export const boardsAndPanelEmpanelmentRegistrationReviewAndApproval = async (values) => {
  try {

    const result = await axios.post(`${api}/boardsAndPanel/reviewAndApproval/${values.id}`,values);
    return result;
  } catch (error) {
    return [];
  }
};



export const boardsAndPanelEmpanelmentRegReOpen = async (values) => {
  try {
    const result = await axios.post(`${api}/boardsAndPanel/empanelmentRegReOpen/${values.id}`,values);
    return result;
  } catch (error) {
    return [];
  }
};


export const boardsAndPanelEmpanelMembershipStatus = async (values) => {
  try {
    const result = await axios.post(`${api}/boardsAndPanel/empanelMembershipStatus/${values.id}`,values);
    return result;
  } catch (error) {
    return [];
  }
};

